import { Component, Input } from '@angular/core';
import { UICardModule } from '@homepower-co/shared-ui-angular';

@Component({
  selector: 'app-recent-activity-card',
  standalone: true,
  imports: [UICardModule],
  templateUrl: './recent-activity-card.component.html',
  styleUrls: ['./recent-activity-card.component.scss'],
})
export class RecentActivityCardComponent {
  @Input() newUsers = 2;
  @Input() modifiedRoles = 2;
  @Input() newApps = 1;
}
